/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useProducts } from '../context/ProductsContext';
import { 
  RiAddLine, 
  RiEditLine, 
  RiDeleteBack2Fill, 
  RiImageLine,
  RiCloseLine
} from 'react-icons/ri';
import toast from 'react-hot-toast';

const ManageProducts = () => {
  const { products, addProduct, updateProduct, deleteProduct, loading, error } = useProducts();
  
  const [editingId, setEditingId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    description: '',
    price: '',
    image: null,
    imageUrl: '',
    removeImage: false
  });

  const categories = [
    { id: 'injection', name: 'Injections' },
    { id: 'tablets', name: 'Tablets' },
    { id: 'capsules', name: 'Capsules' },
    { id: 'equipment', name: 'Equipment' }
  ];

  const openAddModal = () => {
    console.log('Opening add modal');
    setEditingId(null);
    setFormData({
      name: '',
      category: '',
      description: '',
      price: '',
      image: null,
      imageUrl: '',
      removeImage: false
    });
    setShowModal(true);
  };

  const openEditModal = (product) => {
    console.log('Opening edit modal for:', product);
    setEditingId(product.id);
    setFormData({
      name: product.name || '',
      category: product.category || '',
      description: product.description || '',
      price: product.price || '',
      image: null,
      imageUrl: product.imageUrl || '',
      removeImage: false
    });
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingId(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData(prev => ({
        ...prev,
        image: file,
        imageUrl: URL.createObjectURL(file),
        removeImage: false
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const payload = { ...formData };
      
      if (editingId) {
        await updateProduct(editingId, payload);
        toast.success('Product updated successfully');
      } else {
        await addProduct(payload);
        toast.success('Product added successfully');
      }
      
      closeModal();
    } catch (error) {
      toast.error('Error saving product');
    }
  };

  const handleDelete = async (id, e) => {
    e?.stopPropagation();
    
    if (window.confirm('Are you sure you want to delete this product?')) {
      try {
        await deleteProduct(id);
        toast.success('Product deleted successfully');
      } catch (error) {
        toast.error('Error deleting product');
      }
    }
  };

    const getImageUrl = (imageUrl) => {
    if (!imageUrl) return '/assets/img/placeholder.png';
    if (imageUrl.startsWith('/uploads')) {
      const apiUrl = 'https://farmo.zuddo.biz/api';
      const backendOrigin = apiUrl.replace(/\/api\/?$/, '');
      return `${backendOrigin}${imageUrl}`;
    }
    return imageUrl;
  };
  if (loading) return <div className="loading-state">Loading products...</div>;
  if (error) return <div className="error-state">Error: {error}</div>;

  const productsList = Array.isArray(products) ? products : [];

  return (
    <div className="manage-products">
      <div className="page-header">
        <h2>Manage Products</h2>
        <button 
          className="btn btn-primary"
          onClick={openAddModal}
          type="button"
        >
          <RiAddLine /> Add New Product
        </button>
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{editingId ? 'Edit Product' : 'Add New Product'}</h3>
              <button className="modal-close" onClick={closeModal}>
                <RiCloseLine />
              </button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Product Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Category *</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Price ($)</label>
                <input
                  type="number"
                  name="price"
                  value={formData.price}
                  onChange={handleInputChange}
                  step="0.01"
                  min="0"
                />
              </div>

              <div className="form-group">
                <label>Description *</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  rows="4"
                  required
                />
              </div>

              <div className="form-group">
                <label>Product Image</label>
                <div className="image-upload">
                  {formData.imageUrl ? (
                    <img src={formData.imageUrl} alt="Preview" className="image-preview" />
                  ) : (
                    <div className="image-placeholder">
                      <RiImageLine />
                      <span>Upload Image</span>
                    </div>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    className="image-input"
                  />
                </div>
                
                {editingId && formData.imageUrl && !formData.image && (
                  <div className="checkbox-group">
                    <label>
                      <input
                        type="checkbox"
                        name="removeImage"
                        checked={formData.removeImage}
                        onChange={handleInputChange}
                      /> Remove existing image
                    </label>
                  </div>
                )}
              </div>

              <div className="modal-actions">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  {editingId ? 'Update' : 'Add'} Product
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {productsList.length === 0 ? (
        <div className="no-products">
          <p>No products found. Click "Add New Product" to create one.</p>
        </div>
      ) : (
        <div className="products-grid">
          {productsList.map(product => (
            <div key={product.id} className="product-card">
              <div className="product-image">
                {product.image_url ? (
                  <img 
                  src={getImageUrl(product.image_url)}
                  alt={product.name} />
                ) : (
                  <div className="no-image">
                    <RiImageLine size={32} />
                  </div>
                )}
                <div className="product-actions">
                  <button 
                    onClick={() => openEditModal(product)} 
                    className="action-btn edit"
                    title="Edit product"
                    type="button"
                  >
                    <RiEditLine />
                  </button>
                  <button 
                    onClick={(e) => handleDelete(product.id, e)} 
                    className="action-btn delete"
                    title="Delete product"
                    type="button"
                  >
                    <RiDeleteBack2Fill />
                  </button>
                </div>
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <span className="product-category">
                  {categories.find(c => c.id === product.category)?.name || product.category}
                </span>
                <p className="product-description">{product.description}</p>
                {product.price && (
                  <p className="product-price">
                    ${parseFloat(product.price).toFixed(2)}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ManageProducts;